import React, { Component } from "react";
import "./NewFinancing.scss";
import { Breadcrumb, Button, message, Steps } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { FaAngleLeft, FaAngleRight, FaTimes } from "react-icons/fa";
import Customerdata from "../../components/Customerdata/Customerdata";
import Debtsdata from "../../components/Debtsdata/Debtsdata";
import Calculation from "../../components/Calculation/Calculation";
import PropertyDetails from "../../components/PropertyDetails/PropertyDetails";
import Documents from "../../components/Documents/Documents";
import momenthijri from "moment-hijri";
import { parsePhoneNumber } from "react-phone-number-input";
import {
  RegisterCustomer,
  AddOrUpdateFinancingRequest,
  EditCustomer,
  UpdateFinancingRequestStatus,
} from "../../network/customer.network";
import { connect } from "react-redux";
import { setUserRequest } from "../../redux/user/user.action";
const { Step } = Steps;

class NewFinancing extends Component {
  state = {
    current: 0,
    customerData: {},
    saveCustomer: true,
    customerId: "",
    employerId: 0,
    jobTitleId: 0,
    orderType: 1,
    IsRatio: true,
    OrderData: {},
    btnLoading: false,
    requestId: 0,
  };

  next = () => {
    this.setState({ current: this.state.current + 1 });
  };

  prev = () => {
    this.setState({ current: this.state.current - 1 });
  };

  submitForm = (values, params) => {
    console.log(values, "valuesvaluesvalues new fincance");
    return false;
    if (this.state.current === 0) {
      this.setState({ btnLoading: true });
      let date = values.customerDate;
      if (typeof values.customerDate !== "string")
        date =
          values.customerDate.year +
          "/home" +
          values.customerDate.month +
          "/home" +
          values.customerDate.day;
      const phoneNumber = parsePhoneNumber(values.customerPhone || "");
      let body = {
        NationalIdentityNumber: values.customerID,
        EmployerName: values.customerWorkName,
        BirthDate: momenthijri(date, "YYYY/M/D").format("YYYY-MM-DD"),
        Salary: values.customerSalary,
        HousingAllowance: values.customerAlt,
        TransportationAllowance: values.customerTrans,
        IsSupported: values.support ? true : false,
        JobTitleId: params[0].jobTitle,
        EmployerId: params[0].employerTitle,
        GenderId: values.customerGender,
        CityId: values.customerArea,
        BankId: values.customerBank,
        PhoneNumber: phoneNumber.nationalNumber,
        PhoneKey: phoneNumber.countryCallingCode,
        Email: values.customerEmail,
        FullName: values.customerName,
        Id: params[0].custID,
        IdentityId: params[0].IdentityId,
      };
      if (params[0].custID === 0 || params[0].custID === "") {
        let newBody = {
          ...body,
          Password: "P@ssw0rd123",
          ConfirmPassword: "P@ssw0rd123",
          ProfileImage: "",
        };
        RegisterCustomer(
          newBody,
          (res) => {
            this.setState({
              customerData: res.data.model,
              customerId: res.data.model.Id,
              btnLoading: false,
            });
            this.props.setUserRequest({ CustomerId: res.data.model.Id });
            this.setState({ current: this.state.current + 1 });
          },
          (error) => {
            if (error.Code === 26) message.error("هذا العميل موجود بالفعل");
            else if (error.Code === 24)
              message.error("البريد الإلكترونى موجود لدى عميل آخر");
            else if (error.Code === 4 || error.Code === 22)
              message.error("رقم الهاتف موجود بالفعل لعميل آخر");
            this.setState({ btnLoading: false });
          }
        );
      } else {
        this.setState({ customerId: params[0].custID });
        EditCustomer(
          body,
          (res) => {
            this.setState({ customerData: res.data.model, btnLoading: false });
            this.props.setUserRequest({ CustomerId: this.state.customerId });
            this.setState({ current: this.state.current + 1 });
          },
          (error) => {
            if (error.Code === 26) message.error("هذا العميل موجود بالفعل");
            else if (error.Code === 24)
              message.error("البريد الإلكترونى موجود لدى عميل آخر");
            else if (error.Code === 4)
              message.error("رقم الهاتف موجود بالفعل لعميل آخر");
            this.setState({ btnLoading: false });
          }
        );
      }

      // this.setState({btnLoading:false});
    }
    // else if(this.state.current === 1){
    //   // this.setState({customerData : {...values}, btnLoading: true});
    //   this.setState({OrderData:values, btnLoading: true});
    //   this.props.setUserRequest({...this.props.userRequest, ...this.state.OrderData, IsRatio: params[0].IsRatio});
    //   this.setState({btnLoading:false});
    //   this.setState({ current: this.state.current + 1 });
    // }
    else if (this.state.current === 1) {
      console.log(this.props.userRequest, "this.props.userRequest");
      // return false;
      this.setState({ btnLoading: true });
      // if(params.length === 0){
      //   message.error("يجب أن تختار التمويل المناسب");
      //   this.setState({btnLoading:false});
      // }
      if (!params.includes("1")) {
        message.error("يجب أن تختار التمويل العقاري");
        this.setState({ btnLoading: false });
      } else {
        const phoneNumber = parsePhoneNumber(values.customerPhone || "");
        let body;
        this.state.requestId === 0
          ? (body = {
              Id: 0,
              CustomerId: this.props.userRequest.CustomerId,
              FinanceRequestSourceId: 2,
              FinanceRequestStatusId: 1,
              FinancingAgencyId: null,
              ServiceTypeId: 1,
              // Profit: 2.5,
              IsRatio: true,
              MediationContractUrl: null,
              CarFinancingRequest: {
                CarModelId:
                  values?.CarModelId || this.props.userRequest.CarModelId,
                CarColorId:
                  values?.CarColorId || this.props.userRequest.CarColorId,
              },
            })
          : (body = {
              ContactEmployeeId: this.props.userRequest.ContactEmployeeId,
              QualityEmployeeId: this.props.userRequest.QualityEmployeeId,
              FinancingAgencyId: this.props.userRequest.FinancingAgencyId,
              ServiceTypeId: 1,
              Profit: 2.5,
              IsRatio: true,
              MediationContractUrl: null,
              CustomerFollowUpStatusId:
                this.props.userRequest.CustomerFollowUpStatusId,
              CustomerId: this.props.userRequest.CustomerId,
              Id: this.state.requestId,
              FinanceRequestSourceId: 2,
              FinanceRequestStatusId: 1,
              CarFinancingRequest: {
                CarModelId:
                  values?.CarModelId || this.props.userRequest.CarModelId,
                CarColorId:
                  values?.CarColorId || this.props.userRequest.CarColorId,
              },
            });
        AddOrUpdateFinancingRequest(
          body,
          (res) => {
            this.props.setUserRequest(res.data.model);
            this.setState({ btnLoading: false });
            setTimeout(() => {
              this.setState({
                current: this.state.current + 1,
                requestId: res.data.model.Id,
              });
            }, 300);
          },
          () => {
            message.error("حدث خطأ ما حاول مرة أخرى");
            this.setState({ btnLoading: false });
          }
        );
      }
    } else if (this.state.current === 2) {
      this.setState({ current: this.state.current + 1 });
    } else if (this.state.current === 3) {
      this.setState({ current: this.state.current + 1 });
    } else if (this.state.current === 4) {
      this.setState({ current: this.state.current + 1 });
    }
  };

  getcustomValues = (st) => {
    if (this.state.current === 0) {
      this.setState({
        customerId: st.custId,
        employerId: st.employerTitle,
        jobTitleId: st.jobTitle,
      });
    } else if (this.state.current === 1) {
      this.setState({ IsRatio: st });
    }
  };
  setLoadingSendBtn = (loading = true) => {
    this.setState({ btnLoading: loading });
  };

  render() {
    const { current } = this.state;
    const { userRequest } = this.props;
    const steps = [
      {
        title: "طلب سيارة",
        content: (
          <Customerdata
            submitForm={this.submitForm}
            clientData={this.state.customerData}
            setLoadingSendBtn={this.setLoadingSendBtn}
          />
        ),
      },
      // {
      //   title: "بيانات الطلب",
      //   content: <OrderData submitForm={this.submitForm} Data={this.state} />,
      // },
      // {
      //   title: "بيانات السياره",
      //   content: <PropertyDetails submitForm={this.submitForm} />,
      // },
      // {
      //   title: "المديونيات",
      //   content: (
      //     <Debtsdata
      //       submitForm={this.submitForm}
      //       nextStep={() => this.setState({ current: this.state.current + 1 })}
      //     />
      //   ),
      // },
      // {
      //   title: "الحسبة",
      //   content: <Calculation submitForm={this.submitForm} />,
      // },
      // {
      //   title: "المستندات",
      //   content: <Documents submitForm={this.submitForm} />,
      // },
    ];
    return (
      <div className="finance-page-wrapper">
        <div className="header-img-holder">
          <div className="container">
            <div className="finance-header">
              <div className="finance-header-first">
                <Breadcrumb separator=">">
                  <Breadcrumb.Item>
                    <Link to="/home">
                      <HomeOutlined />
                      <p className="link-name">الرئيسية</p>
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to="/orders">
                      <p className="link-name">الطلبات</p>
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to="/orders">
                      <p className="link-name">المتابعه</p>
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item className="last-bread">
                    طلب جديد
                  </Breadcrumb.Item>
                </Breadcrumb>
                <h1>طلب تمويل جديد</h1>
              </div>
              <div className="finance-header-sec">
                {current >= 3 && (
                  <div className="form-header-action">
                    {/* <Button className="submit-btn" onClick={() => this.props.history.push("/orders")}>
                    <FaSave />
                    حفظ لوقت لاحق
                  </Button> */}
                    <Button
                      danger
                      className="cancel-btn"
                      onClick={() => {
                        UpdateFinancingRequestStatus(
                          userRequest?.Id,
                          5,
                          (res) => {
                            message.success("تم الغاء طلب التمويل بنجاح");
                          },
                          (err) => {
                            //console.log(err)
                          }
                        );
                        this.props.history.push("/orders");
                      }}
                    >
                      <FaTimes />
                      الغاء الطلب
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="finance-content">
          <div className="container">
            <div className="finance-steps-wrapper">
              <Steps
                direction="vertical"
                current={current}
                className="steps-sidebar-holder"
              >
                {steps.map((item) => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>
              <div className="steps-content">{steps[current].content}</div>
            </div>
            {
              <div className="steps-action">
                {current > 0 && (
                  <Button
                    onClick={() => this.prev()}
                    size="large"
                    key="2"
                    className="solid-fill"
                  >
                    <FaAngleRight />
                    الخطوه السابقه
                  </Button>
                )}
                {current < steps.length - 1 && (
                  <Button
                    loading={this.state.btnLoading}
                    type="primary"
                    className={`mr-a ${current === 3 && "d-nonenn"}`}
                    form={`orderForm${current}`}
                    key="submit"
                    htmlType="submit"
                    size="large"
                  >
                    الخطوه التاليه
                    <FaAngleLeft />
                  </Button>
                )}
                {/* {current === steps.length - 1 && (
                  <Button type="primary" size="large">
                    <Link
                      to={{
                        pathname: "/done",
                        state: { orderId: userRequest.Id },
                      }}
                    >
                      إرسال
                    </Link>
                  </Button>
                )} */}
                <Button
                  loading={this.state.btnLoading}
                  type="primary"
                  className={`mr-a ${current === 3 && "d-nonenn"}`}
                  form={`orderForm${current}`}
                  key="submit"
                  htmlType="submit"
                  size="large"
                >
                  إرسال
                  <FaAngleLeft />
                </Button>
                {/* <Button type="primary" size="large">
                  إرسال
                </Button> */}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userRequest: state.user.userRequest,
});
const MapDispatchToProps = (dispatch) => ({
  setUserRequest: (data) => dispatch(setUserRequest(data)),
});
export default connect(mapStateToProps, MapDispatchToProps)(NewFinancing);
